
import React, { PropTypes } from 'react';

export class Pointer extends React.Component {

  static propTypes = {
    color: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string
  };

  render () {
    const stroke = this.props.color === 'primary' || typeof this.props.color === 'undefined'
      ? '#00587c'
      : this.props.color;

    return (
      <svg
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        width={this.props.width || '36'}
        height={this.props.height || '36'}
        viewBox='0 0 36 36'
        fill="none"
      >
        <circle cx="18" cy="18" r="17" strokeWidth="2" stroke={stroke}/>
        <path
          d="M11.8286 18H23.6572M23.6572 18L18.5143 23.1428M23.6572 18L18.5143 12.8571"
          stroke={stroke}
          strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export default Pointer;



/** WEBPACK FOOTER **
 ** ./src/components/svg/pointer.js
 **/